import { sxhr, sxhrHeaders, sxhrRequest } from "fire-wind-water/sxhr";
import { Subject, Observable } from "rxjs";
import { getChannelParams, URLS } from "../sbase";
// import axios from 'axios';
import { cr, ck} from "fire-wind-water";
import { interact } from "fire-wind-water/tools/interact";
//
// let instance = axios.create();
// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
//
// instance.interceptors.request.use((config) => {
//   'use strict';
//   if (config.method === 'post' || config.method === 'POST') {
//     cr.extend(true, config.data, {browseInfo: interact.browseInfo});
//     if (config.isNotParam !== 1) {
//       config.data = cr.param(config.data);
//     }
//   }
//   return config;
// }, (error) => {
//   'use strict';
//   return Promise.reject(error);
// });
sxhrRequest(config => {
  if (config.method === "post" || config.method === "POST") {
    cr.extend(true, config.data, { browseInfo: interact.browseInfo });
  }
  return config;
});
sxhrHeaders("Content-Type", "text/plain");

function post(path, info, config) {
  "use strict";
  return new Promise((resolve, reject) => {
    sxhr
      .post(config.url + path, info, config)
      .then(
        res => {
          resolve(res.data.body);
        },
        err => {
          reject(err);
        }
      )
      .catch(error => {
        reject(error);
      });
  });
}

export const http = {
  post: post
};

function getPostParams(info) {
  const miniToken = ck.cookie("miniToken") || null;
  const programType = ck.cookie("programType") || null;
  const programId = ck.cookie("programId") || null;
  const programUserId = ck.cookie("programUserId") || null;
  const fromUserId = ck.cookie("fromUserId") || null;
  const marketingSess = ck.cookie("marketingSess") || null;
  info.miniToken = miniToken;
  info.programType = programType;
  info.programId = programId;
  info.programUserId = programUserId;
  info.fromUserId = fromUserId;
  info.marketingSess = marketingSess;
  info.browseInfo = getChannelParams();
  return info;
}

function post$(path, info, config, sub) {
  const $subject = sub || new Subject();
  info = getPostParams(info);
  sxhr
    .post((config && config.url ? config.url : URLS.url) + path, info)
    .then(
      res => {
        $subject.next(config && config.isNotData ? res.data : res.data.body);
        $subject.complete();
      },
      err => {
        if (err.response && err.response.status == 401) {
          $subject.next({ result: 401, desc: "接口错误", data: err });
        } else {
          $subject.next({ result: 1317, desc: "接口错误", data: err });
        }
        $subject.complete();
      }
    )
    .catch(error => {
      return Observable.of(error);
    });
  return $subject;
}

function get$(url, info, config, sub) {
  const $subject = sub || new Subject();
  const miniToken = ck.cookie("miniToken") || null;
  const programType = ck.cookie("programType") || null;
  const programId = ck.cookie("programId") || null;
  const programUserId = ck.cookie("programUserId") || null;
  const fromUserId = ck.cookie("fromUserId") || null;
  const marketingSess = ck.cookie("marketingSess") || null;
  info.miniToken = miniToken;
  info.programType = programType;
  info.programId = programId;
  info.programUserId = programUserId;
  info.fromUserId = fromUserId;
  info.marketingSess = marketingSess;
  sxhr
    .get(url, info, config)
    .then(
      res => {
        $subject.next(res.data);
        $subject.complete();
      },
      err => {
        if (err.response && err.response.status == 401) {
          $subject.next({ result: 401, desc: "接口错误", data: err });
        } else {
          $subject.next({ result: 1317, desc: "接口错误", data: err });
        }
        $subject.complete();
      }
    )
    .catch(error => {
      return Observable.of(error);
    });
  return $subject;
}

function upload$(info) {
  let url = URLS.UploadUrl + "?command=";
  let command = encodeURI(
    JSON.stringify({
      size: 0,
      dst: "01-0300",
      orn: "01-0300",
      sess: "",
      type: 0x0002,
      cmd: "file.upload",
      seq: 0,
      ver: 1000,
      body: ""
    })
  );
  return post$("", info, {
    headers: { "Content-Type": "multipart/form-data" },
    url: url + command
  });
}

function http$(url, path, info, config) {
  const $subject = new Subject();
  info = getPostParams(info);
  const curl = config && config.cacheUrl ? config.cacheUrl : URLS.cacheUrl;
  sxhr
    .get(`${curl}${url}.json?time_stamp=${new Date().getTime()}`, config)
    .then(
      res => {
        $subject.next(res.data.body);
        $subject.complete();
      },
      () => {
        post$(path, info, config, $subject);
      }
    )
    .catch(() => {
      post$(path, info, config, $subject);
    });
  return $subject;
}

export const $sxhr = {
  post: post$,
  get: get$,
  upload: upload$,
  http: http$
};
